import { createAction, props } from '@ngrx/store';

import { ResetPasswordBody } from '@lockton-apps/shared/interfaces';

export enum ResetPasswordActionTypes {
  ResetPassword = '[Reset Password Page] Reset Password',
}

export const ResetPasswordActions = {
  resetPassword: createAction(
    ResetPasswordActionTypes.ResetPassword,
    props<{ resetPasswordBody: ResetPasswordBody }>()
  ),
};
